import React, { useState } from 'react';

const HospitalAdmittanceForm = ({ onFormSubmit, incidentId }) => {
    const [form, setForm] = useState({
        patientName: '',
        dateOfBirth: '',
        admissionDate: '',
        reason: '',
        doctor: '',
        notes: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        if (onFormSubmit) {
            onFormSubmit(form, incidentId);
        }
        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>Patient Name:</label>
                <input
                    type="text"
                    name="patientName"
                    value={form.patientName}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Date of Birth:</label>
                <input
                    type="date"
                    name="dateOfBirth"
                    value={form.dateOfBirth}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Admission Date:</label>
                <input
                    type="date"
                    name="admissionDate"
                    value={form.admissionDate}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Reason for Admission:</label>
                <input
                    type="text"
                    name="reason"
                    value={form.reason}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Doctor:</label>
                <input
                    type="text"
                    name="doctor"
                    value={form.doctor}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Notes:</label>
                <textarea
                    name="notes"
                    value={form.notes}
                    onChange={handleChange}
                />
            </div>
            <button 
                type="submit" 
                disabled={loading}
                className={loading ? 'submit-button disabled' : 'submit-button'}
            >
                {loading ? "Submitting..." : "Submit"}
            </button>
        </form>
    );
};

export default HospitalAdmittanceForm;